import React from 'react';

import { Box, Typography } from '@mui/material';
import BlockSidebarForm from '@wp-block-builder/components/BlockSidebarForm';
import { SidebarApiClientProvider } from '@wp-block-builder/components/SidebarApiClientContext';
import { useCurrentBlockId } from '@wp-block-builder/editor/hooks';

import useSidebarApiClient from './useSidebarApiClient';

export default function InspectSidebar() {
  const currentBlockId = useCurrentBlockId();
  const apiClient = useSidebarApiClient();

  if (!currentBlockId) {
    return (
      <Box sx={{ m: 3, p: 1, border: '1px dashed', borderColor: 'divider' }}>
        <Typography color="text.secondary">No block selected. Click on a block to inspect.</Typography>
      </Box>
    );
  }

  return (
    <SidebarApiClientProvider value={apiClient}>
      <Box p={3}>
        <BlockSidebarForm blockId={currentBlockId} />
      </Box>
    </SidebarApiClientProvider>
  );
}
